export const environment = {
  production: false,
  apiBaseUrl: 'http://supercheck.by/',
};
